import type { Observable as ObservableType } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import type { Issue } from '@atlassian/jira-software-backlog-uif-types/src/index.tsx';
import { transformCard } from '../../../model/issue/utils/index.tsx';
import type { Card } from '../../../model/types.tsx';
import { fetchIssue } from '../../../rest/fetch-issue/index.tsx';
import { inlineCreateIssue } from '../../../rest/inline-create-issue/index.tsx';
import type { InlineCreateResponse } from '../../../rest/inline-create-issue/types.tsx';
import type { EpicIssueTypeState } from '../../../state/reducers/config/epic/types.tsx';
import type { ServiceContext } from '../../service-context/index.tsx';
import type { CreateCardServiceOptions } from './types.tsx';

const fetchNewlyCreatedIssue =
	(boardId: string) =>
	(inlineCreateResponse: InlineCreateResponse): ObservableType<Issue> =>
		fetchIssue(boardId, Number(inlineCreateResponse.issue.issueId));

const updateIssueConfigStore =
	(
		epicIssueType: EpicIssueTypeState | null,
		storeFieldsFromFetchIssuesData: (
			issues: Issue[] | null,
			epicIssueType: EpicIssueTypeState | null,
		) => void,
	) =>
	(issue: Issue): Issue => {
		storeFieldsFromFetchIssuesData([issue], epicIssueType);
		return issue;
	};

const transformIssueToCard = (issue: Issue): Card[] => [transformCard(issue)];

export function inlineCardCreateService(
	serviceContext: ServiceContext,
	{
		summary,
		issueTypeId,
		contexts,
		overrides,
		epicIssueType,
		storeFieldsFromFetchIssuesData,
	}: CreateCardServiceOptions,
): ObservableType<Card[]> {
	return inlineCreateIssue({
		summary,
		issueTypeId,
		contexts,
		overrides,
	})
		.flatMap(fetchNewlyCreatedIssue(serviceContext.boardId))
		.map(updateIssueConfigStore(epicIssueType, storeFieldsFromFetchIssuesData))
		.map(transformIssueToCard);
}
